const charts = new WeakMap();
function placeChart(root, link) {
  const picker = root.closest('.product-details')?.querySelector('variant-picker');
  const fieldset = [...(picker?.querySelectorAll('fieldset') || [])].find(element => element.querySelector('input[data-option-name]')?.dataset.optionName === root.dataset.snOption);
  const legend = fieldset?.querySelector('legend');
  if (!legend || legend.contains(link)) return;
  legend.querySelectorAll('[data-sn-open]').forEach(stale => stale.remove());
  legend.classList.add('sn-size-chart-inlabel');
  legend.append(link);
  root.classList.add('sn-size-chart--moved');
}
function initializeCharts() {
  document.querySelectorAll('.sn-size-chart').forEach(root => {
    if (charts.has(root)) { placeChart(root, charts.get(root)); return; }
    const overlay = root.querySelector('.sn-size-chart__overlay');
    const ownLink = root.querySelector('[data-sn-open]');
    if (!overlay) return;
    const link = ownLink || document.querySelector(`[data-sn-open="${CSS.escape(overlay.id)}"]`);
    if (!link) return;
    charts.set(root, link);
    let previousFocus;
    let previousOverflow;
    const close = () => {
      overlay.hidden = true;
      document.body.style.overflow = previousOverflow || '';
      if (previousFocus?.isConnected) previousFocus.focus();
    };
    link.addEventListener('click', () => {
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      overlay.querySelector('[data-sn-close]')?.focus();
    });
    overlay.addEventListener('click', event => {
      if (event.target === overlay || event.target.closest('[data-sn-close]')) close();
      const unit = event.target.closest('[data-sn-unit]');
      if (!unit) return;
      overlay.querySelectorAll('[data-sn-unit]').forEach(button => {
        const selected = button === unit;
        button.classList.toggle('is-on', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      overlay.querySelectorAll('[data-sn-table]').forEach(table => { table.hidden = table.dataset.snTable !== unit.dataset.snUnit; });
    });
    overlay.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const controls = [...overlay.querySelectorAll('button, [href], input, select, [tabindex="0"]')].filter(element => !element.disabled && element.getClientRects().length);
      const first = controls[0];
      const last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    overlay.querySelectorAll('[data-sn-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('is-on'))));
    placeChart(root, link);
  });
}
let queued = false;
new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => { queued = false; initializeCharts(); });
}).observe(document.documentElement, { childList: true, subtree: true });
initializeCharts();
